<template>
    <div class="container-erp" :style="{'margin': marginAuto}">
        <div v-show="loading" class="loading">
            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
        </div>

        <div v-show="!loading" class="container-erp-content">
            <div v-if="showView && (hasIntegrations || isAddIntegration)">
                <router-view :key="$route.fullPath" />
            </div>

			<div v-else>
                <menu-card-erp icon="fal fa-plug" title="Gerenciar integração com ERPs">
                    Crie e gerencie integrações com o seu ERP contratado para sua operação e aumente a
                    produtividade da sua equipe de vendas na gestão de
                    <span class="content-info">disponibilidade</span>
                    e envio de
                    <span class="content-info">proposta</span>.
                    <div class="button-erp">
                        <router-link to="/marketing/integracoes/erp/adicionar">
                            <ui-button>
                                <em class="fal fa-plus"/>
                            </ui-button>
                        </router-link>
                    </div>
                    <span class="primary-integration">
                        Adicione sua primeira <strong>integração</strong>
                    </span>
                </menu-card-erp>
            </div>
        </div>
    </div>
</template>


<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { MenuCardErp } from '@/components/ui-facilita/marketing/erp/menu-card-erp'

import { utilMixin } from '@/mixins'

import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'integration-erp',

	components: {
		uiLoadIndicator,
		MenuCardErp,
		uiButton,
	},

	mixins: [utilMixin],

	data() {
		return {
			marginAuto: 'auto',
			showView: false
		}
	},

	computed: {
		...mapGetters('ERP', {
			integrations: 'getIntegrations',
			components: 'getComponents',
			loading: 'getLoading'
		}),
		/**
		 * Computed property que verifica se existem integrações cadastradas
		 */
		hasIntegrations() {
			return !!this.integrations.length
		},
		/**
		 * Computed property que define se a rota atual é a de adicionar integrações
		 */
		isAddIntegration() {
			return this.$route.name === 'marketing.integrations.erp.add'
		}
	},

	created: async function () {
		try {
			this.setLoading(true)
			await this.loadComponents()
			if (!this.$mx_hasValue(this.components)) {
				throw new Error('Não foram definidas configurações de componentes para as integrações!')
			}

			await this.loadIntegrations()
			if (this.hasIntegrations && this.$route.name === 'marketing.integrations.erp') {
				this.$router.push({ name: 'marketing.integrations.erp.integrations' })
					.catch(() => {})
			}
			this.setLoading(false)
			// Caso todas as configurações foram carregadas, mostra-se a subrota desejada
			this.showView = true

		} catch (error) {
			console.log(error)
			this.$toastr.e(error)
			this.$router.push('/')
		}
	},

	mounted() {
		this.isEnterprises()
	},

	methods: {
		...mapActions('ERP', [
			'setLoading',
			'loadIntegrations',
			'loadComponents'
		]),

		isEnterprises() {
			const body = document.querySelector('.page-panel > .body')

			if (this.$route.name === 'marketing.integrations.erp.enterprises') {
				body.style = 'padding: 0; background: #fff'
				return this.marginAuto = 'initial'
			} else if (this.$route.name === 'products.units') {
				return this.marginAuto = 'initial'
			}
		},
	},
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>